module.exports = __webpack_public_path__ + "static/media/panning.5e27dedf.png";